module.exports = __webpack_public_path__ + "img/interest.1660c4f2.png";